import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _setImmediate from '@babel/runtime-corejs3/core-js/set-immediate';
import * as React from 'react';
import classNames from 'classnames';
import { prependPrefix } from '../../utils/style.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var LegacyDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(LegacyDropdown, _React$Component);

  var _super = _createSuper(LegacyDropdown);

  function LegacyDropdown(props) {
    var _this;

    _classCallCheck(this, LegacyDropdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.packup();

      document.removeEventListener('click', _this.handleClickOutside);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var _this$state = _this.state,
          active = _this$state.active,
          clickOutsideToPackup = _this$state.clickOutsideToPackup;

      if (active) {
        _this.packup();
      } else {
        _this.drop();

        if (clickOutsideToPackup) {
          _setImmediate(function () {
            document.addEventListener('click', _this.handleClickOutside);
          });
        }
      }
    });

    var _this$props = _this.props,
        _active = _this$props.active,
        _clickOutsideToPackup = _this$props.clickOutsideToPackup;
    _this.state = {
      active: !!_active,
      clickOutsideToPackup: _clickOutsideToPackup === undefined ? true : _clickOutsideToPackup
    };
    return _this;
  } // eslint-disable-next-line @typescript-eslint/naming-convention


  _createClass(LegacyDropdown, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var active = nextProps.active;

      if (active !== undefined && active !== this.state.active) {
        this.setState({
          active: active
        });
      }
    }
  }, {
    key: "packup",
    value: function packup() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "drop",
    value: function drop() {
      this.setState({
        active: true
      });
    } // FIXME: 加上是否为组件外的检测

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          dropdownClassName = _this$props2.dropdownClassName,
          dropdownSelectedClassName = _this$props2.dropdownSelectedClassName,
          value = _this$props2.value,
          loading = _this$props2.loading,
          children = _this$props2.children;
      var active = this.state.active;
      var baseClassName = prependPrefix('legacy-dropdown');

      if (loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: classNames(baseClassName, className, 'loading')
        }, /*#__PURE__*/React.createElement("div", {
          className: "dropdown-loading-icon"
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classNames(baseClassName, className, {
          active: active
        }),
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement("span", {
        className: classNames('select-item', dropdownSelectedClassName),
        title: typeof value === 'string' ? value : ''
      }, value), /*#__PURE__*/React.createElement("ul", {
        className: classNames('dropdown-menu', dropdownClassName)
      }, children));
    }
  }]);

  return LegacyDropdown;
}(React.Component);

export { LegacyDropdown };
